@if (station) {
  <div class="used-workingarea-item" [ngClass]="{'selected': selected}">
    <sc-flex fitHeight vertical stretchContent>
      <div>
        <sc-flex>
          <div class="station-name" [ngClass]="{'exceeded':transport.processing.processingDurationExceeded}">
          {{station.name}}</div>
          <sc-content-spacer grow></sc-content-spacer>
          <div class="duration" [ngClass]="{'critical':transport.processing.processingDurationCritical}">
            <sc-flex>
              @if (transport.masterdata.preloading) {
                <sc-icon iconClass="fa-arrow-right"></sc-icon>
              }
              {{transport.processing.processingTime}} @if (!transport.masterdata.preloading) {
              <span></span>
            }
          </sc-flex>
        </div>
      </sc-flex>
    </div>
    <sc-content-spacer vertical [half]="true"></sc-content-spacer>
    <sc-flex class="identity" [centered]="true">
      <app-transport-scope-icon [scope]="transport.scope"></app-transport-scope-icon>
      <sc-content-spacer></sc-content-spacer>
      <div class="identity-label">{{transport.identifyingNumberplate}}</div>
    </sc-flex>
    <sc-content-spacer vertical [half]="true"></sc-content-spacer>
    <div class="carrier">
      {{transport.masterdata.carrier}}
    </div>
    <sc-content-spacer vertical [half]="true"></sc-content-spacer>
    <sc-flex [centered]="true">
      @if (transport.masterdata.important) {
        <div class="status-icon">
          <sc-icon iconClass="fa-exclamation"></sc-icon>
        </div>
      }
      @if (transport.masterdata.dangerousGoods) {
        <div class="status-icon">
          <sc-icon iconClass="fa-skull-crossbones"></sc-icon>
        </div>
      }
      @if (transport.processing.pendingTaskState !== TransportTaskStatus.NONE) {
        <div class="status-icon">
          <app-task-state-icon [state]="transport.processing.pendingTaskState"></app-task-state-icon>
        </div>
      }
      @if (transport.masterdata.urgent) {
        <div class="status-icon">
          <sc-icon iconClass="fa-truck-fast"></sc-icon>
        </div>
      }
      @if (transport.processing.inUmbrueckung) {
        <div class="status-icon">
          <sc-icon iconClass="fa-random"></sc-icon>
        </div>
      }
      @if (transport.processing.waitingForPulling) {
        <div class="status-icon">
          <sc-icon iconClass="fa-circle-pause"></sc-icon>
        </div>
      }
      @if (station.stationUsage.ongoingMovementFromStation || station.stationUsage.ongoingMovementToStation) {
        <div class="status-icon"
          >
          <sc-icon iconClass="fa-truck-flatbed"></sc-icon>
        </div>
      }
    </sc-flex>
  </sc-flex>
</div>
}
